export function printPage() {
    const print = document.querySelectorAll(".print");
    !!print && print.forEach(e => { e.addEventListener("click", () => window.print()); });
}
export function copyCurrentURL() {
    const copy = document.querySelectorAll(".copy");
    !!copy && copy.forEach(e => {
        return e.addEventListener("click", () => {
            console.log("copy");
            const url = window.location.href;
            navigator.clipboard.writeText(url).then(() => {
                alert("URL copiée !");
            }).catch(err => {
                console.error("Erreur lors de la copie : ", err);
            });
        });
    });
}
export function setBodyVisibility(state) {
    const body = document.querySelector("body");
    if (state) {
        body.style.overflow = "initial";
    }
    else {
        body.style.overflow = "hidden";
    }
}
export function decodeHtml(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}
export function handleWishListCount() {
    var _a;
    const icone = document.querySelector(".wishlist span");
    const count = (_a = JSON.parse(localStorage.getItem("WishList"))) === null || _a === void 0 ? void 0 : _a.length;
    if (count > 1) {
        icone.style.display = "block";
        icone.innerText = count.toString();
    }
    else {
        icone.innerText = "";
        icone.style.display = "none";
    }
}
